import { Box, Button, Flex, Heading } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { QueryKeyTypes } from '../../lib/types'

interface QuickSelectionsProps {
  onClickCallBack: (item: QueryKeyTypes) => void
  tableType: QueryKeyTypes
}
export const QuickSelections = ({ onClickCallBack, tableType }: QuickSelectionsProps): JSX.Element => {
  const quickElements: QueryKeyTypes[] = ['Services', 'Systems']
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <Box borderRight="2px solid" borderColor="gray.200" mb="4" data-name="quick-selections">
      <Heading as="h4" size="sm" mx="6" my="4">
        Quick Selections
      </Heading>
      <Flex gridGap="2" m="2" mx="4">
        {quickElements.map(item => (
          <Button key={item} onClick={() => onClickCallBack(item)} colorScheme={tableType === item ? 'blue' : 'gray'} size="sm" fontSize="12px">
            {item}
          </Button>
        ))}
        <Button
          key="Product"
          onClick={() => navigate('/product-administration')}
          colorScheme={location.pathname === '/product-administration' ? 'blue' : 'gray'}
          size="sm"
          fontSize="12px"
        >
          Product
        </Button>
      </Flex>
    </Box>
  )
}
